import UnderstandSectionUseCase from "@domains/useCases/Reports/UnderstandingSection/UnderstandingSection";
import UnderstandSectionRepository from "@adapters/repositories/Reports/UnderstandingSection";
import { accountDetails, http } from "../../../../../mainDi/webDi";
export default (function () {
    return {
        understandingSection: new UnderstandSectionUseCase(new UnderstandSectionRepository(http, accountDetails)),
    };
});
